import api from '@/lib/api';
import type {
  PaginatedResponse,
  CancellationReasonCode,
  CancelReasonCategory,
} from '@pms/shared';

// ─── Query / payload types ────────────────────────────────────────────────────

export interface ListCancellationReasonsQuery {
  propertyId: string;
  search?: string | undefined;
  isActive?: boolean | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

export interface CreateCancellationReasonPayload {
  propertyId: string;
  label: string;
  code: string;
  category: CancelReasonCategory;
  requiresNote?: boolean | undefined;
  isActive?: boolean | undefined;
}

export interface UpdateCancellationReasonPayload {
  label?: string | undefined;
  code?: string | undefined;
  category?: CancelReasonCategory | undefined;
  requiresNote?: boolean | undefined;
  isActive?: boolean | undefined;
}

// ─── API functions ────────────────────────────────────────────────────────────

export async function fetchCancellationReasons(
  query: ListCancellationReasonsQuery,
): Promise<PaginatedResponse<CancellationReasonCode>> {
  const { data } = await api.get<PaginatedResponse<CancellationReasonCode>>(
    '/cancellation-reasons',
    { params: query },
  );
  return data;
}

export async function createCancellationReason(
  payload: CreateCancellationReasonPayload,
): Promise<CancellationReasonCode> {
  const { data } = await api.post<CancellationReasonCode>(
    '/cancellation-reasons',
    payload,
  );
  return data;
}

export async function updateCancellationReason(
  id: string,
  payload: UpdateCancellationReasonPayload,
): Promise<CancellationReasonCode> {
  const { data } = await api.patch<CancellationReasonCode>(
    `/cancellation-reasons/${id}`,
    payload,
  );
  return data;
}

export async function deleteCancellationReason(id: string): Promise<void> {
  await api.delete(`/cancellation-reasons/${id}`);
}
